import { CalendarIcon } from 'lucide-react-native';
import { Image, View } from 'tamagui';

import { NextAction } from './NextAction';

export interface BookNextSessionWidgetProps {
    title: string;
    description: string;
    buttonLabel: string;
    guideImageUrl?: string;
    enableBooking?: boolean;
    onPress: () => void;
    maxWidth?: number;
}

export const BookNextSessionWidget = ({
    title,
    description,
    buttonLabel,
    guideImageUrl,
    enableBooking = true,
    onPress,
    maxWidth,
}: BookNextSessionWidgetProps) => {
    // Create guide image icon override if URL is provided
    const guideImageIcon =
        guideImageUrl != null ? (
            <View borderRadius={48} overflow="hidden">
                <Image
                    source={{ uri: guideImageUrl }}
                    style={{
                        width: 48,
                        height: 48,
                    }}
                    width={48}
                    height={48}
                />
            </View>
        ) : undefined;

    return (
        <NextAction
            title={title}
            description={description}
            iconOverride={guideImageIcon}
            primaryAction={{
                text: buttonLabel,
                onPress,
                disabled: !enableBooking,
                icon: CalendarIcon,
            }}
            backgroundColor="$white"
            shadow={true}
            maxWidth={maxWidth}
        />
    );
};
